import { BookOpen, Download, FileText, Image } from "lucide-react";
import { useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FILES = [
  { format: "epub", label: "EPUB para Kindle", icon: BookOpen },
  { format: "docx", label: "DOCX editável", icon: FileText },
  { format: "cover-kindle", label: "Capa Kindle", icon: Image },
  { format: "cover-paperback", label: "Capa paperback", icon: Image },
];

function filenameFrom(response, fallback) {
  const disposition = response.headers.get("content-disposition") || "";
  const match = disposition.match(/filename="?([^";]+)"?/i);
  return match?.[1] || fallback;
}

export default function BookDownloadButtons({ endpoint, query = "", testIdPrefix = "book", includeCredentials = false }) {
  const [loading, setLoading] = useState("");
  const [error, setError] = useState("");

  const downloadFile = async (file) => {
    setLoading(file.format);
    setError("");
    try {
      const response = await fetch(`${API}${endpoint}/${file.format}${query}`, { credentials: includeCredentials ? "include" : "omit" });
      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.detail || "Não foi possível preparar este arquivo.");
      }
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = filenameFrom(response, `30-dias-para-a-liberdade.${file.format}`);
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      window.setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (downloadError) {
      setError(downloadError.message);
    } finally {
      setLoading("");
    }
  };

  return (
    <section className="book-download-panel" data-testid={`${testIdPrefix}-download-panel`}>
      <div className="book-download-copy">
        <span className="book-download-kicker">ARQUIVOS PARA O KDP</span>
        <strong>Baixe o livro completo</strong>
        <p>Inclui as 30 páginas, o apêndice informativo e as capas separadas.</p>
      </div>
      <div className="book-download-grid">
        {FILES.map(({ format, label, icon: Icon }) => (
          <button
            type="button"
            className="book-download-button"
            key={format}
            onClick={() => downloadFile({ format })}
            disabled={Boolean(loading)}
            aria-busy={loading === format}
            data-testid={`${testIdPrefix}-download-${format}-button`}
          >
            <Icon size={16} />
            <span>{loading === format ? "Preparando…" : label}</span>
            <Download size={14} />
          </button>
        ))}
      </div>
      {error && <p className="book-download-error" role="alert" data-testid={`${testIdPrefix}-download-error`}>{error}</p>}
    </section>
  );
}
